import DOMPurify from "dompurify"

/**
 * Sanitizes and adds a value to target object if it's not null or empty
 * Handles both single values and arrays
 */
export function sanitizeAndAddIfNotEmpty(target: Record<string, any>, key: string, value: any) {
  if (value != null && value !== "") {
    if (Array.isArray(value)) {
      const sanitizedArray = value.map(v => DOMPurify.sanitize(String(v))).filter(v => v !== "")
      if (sanitizedArray.length > 0)
        target[key] = sanitizedArray
    }
    else {
      target[key] = DOMPurify.sanitize(String(value))
    }
  }
}

/**
 * Sanitizes foreign query parameters by cleaning both keys and values
 */
export function sanitizeForeignQueries(foreignQueries: Record<string, any>) {
  return Object.fromEntries(
    Object.entries(foreignQueries).map(([k, v]) => [
      DOMPurify.sanitize(String(k)),
      DOMPurify.sanitize(String(v)),
    ]).filter(([k, v]) => k && v),
  )
}
